import * as types from "./constant"

const initialState = {
  loading: false,
  CompanyDashboard: [],
  PolicyDashboard: [],
  LOBLifeIns: [],
  LOBGenIns: [],
  LifeInsuranceDashboard: [],
  GeneralInsuranceDashboard: [],
  employeeData: [],
  error: null,
  PrivacyModal: true,
  companyGraphData: [],
  companyLifeGraphData: [],
  LOBGraphData: [],
  LOBLifeGraphData: []
}

const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_DASH_API_START:
      return {
        ...state,
        Loading: true,
        error: null
      }
    case types.GET_COMPANY_DASH_API_SUCCESS:
      return {
        ...state,
        Loading: false,
        CompanyDashboard: action.payload,
      }
    case types.GET_COMPANY_DASH_API_SUCCESS_LIFE:
      return {
        ...state,
        Loading: false,
        LifeInsuranceDashboard: action.payload,
      }

    case types.GET_LOB_PREMIUM_API_SUCCESS_Gen: {
      return {
        ...state,
        Loading: false,
        LOBGenIns: action.payload,
      }
    }
    case types.GET_LOB_PREMIUM_API_SUCCESS_Life: {
      return {
        ...state,
        Loading: false,
        LOBLifeIns: action.payload,
      }
    }

    case types.GET_COMPANY_DASH_API_FAILURE:
      return {
        ...state,
        Loading: false,
        error: action.payload.message,
      }
    case types.GET_COMPANY_DASH_API_RESET:
      return {
        ...state,
        Loading: false,
        error: null
      }

    case types.SHOW_PRIVACY_MODAL:
      return {
        ...state,
        PrivacyModal: false
      }

    // Employee-graph

    case types.GET_EMPLOYEE_API_START:
      return {
        ...state,
        Loading: true,
        error: null
      }

    case types.GET_EMPLOYEE_API_SUCCESS:
      return {
        ...state,
        Loading: false,
        employeeData: action.payload,
        error: null
      }

    case types.GET_EMPLOYEE_API_FAIL:
      return {
        ...state,
        Loading: false,
        error: action.payload.message,
      }

    case types.GET_COMPANY_GRAPH:
      return {
        ...state,
        loading: true,
        companyGraphData: [],
        companyLifeGraphData: []
      }
    case types.GET_LOB_GRAPH:
      return {
        ...state,
        loading: true,
        LOBGraphData: [],
        LOBLifeGraphData: []
      }

    case types.GET_COMPANY_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        companyGraphData: action.payload
      }

    case types.GET_COMPANY_LIFE_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        companyLifeGraphData: action.payload
      }

    case types.GET_LOB_LIFE_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        LOBLifeGraphData: action.payload
      }
    case types.GET_LOB_GRAPH_SUCCESS:
      return {
        ...state,
        loading: false,
        LOBGraphData: action.payload
      }

    case types.GET_COMPANY_GRAPH_FAILED:
    case types.GET_LOB_GRAPH_FAILED:
      return {
        ...state,
        loading: true,
        error: action.payload.message
      }

    default:
      return state
  }

}

export default DashboardReducer
